import React, { useState } from "react";
import { Paper, Stack, Typography, Box, Tabs, Tab, Fade } from "@mui/material";
import InsightsIcon from "@mui/icons-material/Insights";

import TabCareGaps from "./TabCareGaps";
import TabCoding from "./TabCoding";
import TabNoVisit from "./TabNoVisit";
import InfoButton from "./InfoButton";
import { HELP_CONTENT } from "../../constants/clinicalHelpContent";

/**
 * Panel 4: Insights (3 tabs)
 * Tab 1: Care Gaps, Tab 2: Coding, Tab 3: No Visit
 */
export default function PanelInsights({ careGaps, coding, recall, loading, onCreateTask }) {
  const [tab, setTab] = useState(0);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        height: "100%",
      }}
    >
      <Stack spacing={2}>
        {/* Header */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 28,
              height: 28,
              borderRadius: 1.5,
              bgcolor: "#FEF3C7",
              color: "#D97706",
            }}
          >
            <InsightsIcon sx={{ fontSize: 16 }} />
          </Box>
          <Typography variant="subtitle2" fontWeight={700}>
            Insights
          </Typography>
          <InfoButton helpContent={HELP_CONTENT.insights} />
        </Stack>

        {/* Tabs */}
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="fullWidth"
          sx={{
            minHeight: 32,
            "& .MuiTab-root": {
              minHeight: 32,
              py: 0.5,
              fontSize: "0.72rem",
              textTransform: "none",
              fontWeight: 600,
            },
            "& .MuiTabs-indicator": {
              height: 2,
            },
          }}
        >
          <Tab label="Care Gaps" />
          <Tab label="Coding" />
          <Tab label="No Visit" />
        </Tabs>

        {/* Tab content with fade transition */}
        <Box sx={{ minHeight: 200 }}>
          <Fade in={tab === 0} timeout={150} unmountOnExit>
            <Box>{tab === 0 && <TabCareGaps data={careGaps} loading={loading.careGaps} onCreateTask={onCreateTask} />}</Box>
          </Fade>
          <Fade in={tab === 1} timeout={150} unmountOnExit>
            <Box>{tab === 1 && <TabCoding data={coding} loading={loading.coding} />}</Box>
          </Fade>
          <Fade in={tab === 2} timeout={150} unmountOnExit>
            <Box>{tab === 2 && <TabNoVisit data={recall} loading={loading.recall} onCreateTask={onCreateTask} />}</Box>
          </Fade>
        </Box>
      </Stack>
    </Paper>
  );
}
